export default __webpack_public_path__ + "static/media/accounts.a8f44ea3.svg";